import { TextMessage } from 'components/Dialogue';
import { BaseMsgProps } from '../types';
import { getMetaFromSender } from '../../../utils';
import { AttachmentList } from './AttachmentList';
import { useChatContext } from 'views/Conversation/Chat/contexts/ChatContext';
import { MessageExtendComplex } from '../../MessageExtend/MessageExtendComplex';
import { useGetTranslation } from '../TextMsg';

export const AttachmentMsg = (props: BaseMsgProps) => {
  const { conversation, msg, raw } = props;
  const { botReplyType, attachmentContent } = raw;
  const { sender } = msg;

  const { getTranslation } = useGetTranslation();
  const { singleTransToSysLang } = useChatContext();
  const { layout, color } = getMetaFromSender(sender);

  return (
    <MessageExtendComplex
      raw={raw}
      msg={msg}
      conversation={conversation}
      showSourceContent={false}
      content={
        <div className={`flex flex-col ${layout === 'left' ? 'items-start' : 'items-end'}`}>
          {attachmentContent?.text ? (
            <TextMessage
              className={layout}
              layout={layout}
              color={botReplyType && botReplyType !== 'BRT_UNKNOWN' ? '#F6FFF9' : color}
              content={attachmentContent.text}
              translation={getTranslation(attachmentContent?.translationContent)}
              msg={msg.raw}
              onTranslate={singleTransToSysLang}
            />
          ) : null}
          {attachmentContent?.attachments && attachmentContent.attachments.length > 0 ? (
            <AttachmentList
              msgId={msg.raw.msgId}
              storeId={conversation.storeId}
              list={attachmentContent.attachments}
            />
          ) : null}
        </div>
      }
    />
  );
};
